var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { ImageIcon } from '../../../../assets';
import Text from '../../../Text';
import colors from '../../../../themes/colors';
var TagWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.65);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px;\n"], ["\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.65);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px;\n"])));
var TagWrapperLoading = styled(TagWrapper)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), colors.neutral0);
var ImageLoadingIcon = styled(ImageIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  & path {\n    fill: ", ";\n  }\n"], ["\n  & path {\n    fill: ", ";\n  }\n"])), colors.neutral40);
var CustomCardHeaderTagLoading = function () { return (_jsxs(TagWrapperLoading, { children: [_jsx(ImageLoadingIcon, {}), _jsx(Text, __assign({ color: "neutral40", variant: "tag1Semibold" }, { children: "---" }))] })); };
var CustomCardHeaderTag = function (props) {
    var icon = props.icon, label = props.label, loading = props.loading;
    if (loading)
        return _jsx(CustomCardHeaderTagLoading, {});
    return (_jsxs(TagWrapper, { children: [icon, _jsx(Text, __assign({ variant: "tag1Semibold" }, { children: label }))] }));
};
export default CustomCardHeaderTag;
var templateObject_1, templateObject_2, templateObject_3;
